import type { SystemStyleObject } from '@chakra-ui/react'

const baseStyle: SystemStyleObject = {
  color: 'menu-item-color',
  fontSize: 'sm',
  fontWeight: 'semibold',
  _disabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  _focus: {
    boxShadow: 'none'
  },
  _hover: {
    background: 'neutral.50'
  },
  py: 2,
  px: 3,
  borderRadius: 'sm',
}

export const MenuItem = {
  baseStyle,
}
